<template>
  <div class="modal" v-if="visible">
    <div class="modal-position modal-lg manage-menu">
      <div class="modal-content">
        <div class="modal-header">
          <h5>교육과정 안내 관리</h5>
          <button type="button" class="close" @click="clickCloseModal">×</button>
        </div>
        <div class="modal-body">
          <p>
            ※ 메뉴명은 9글자까지만 작성할 수 있습니다. <br />
            ※ 체크된 메뉴만 표시되며, 번호 순서대로 표시됩니다
          </p>

          <div class="d-flex mt-3">
            <div class="w-100per">
              <h5>템플릿보기</h5>
              <div class="d-flex justify-content-start">
                <b-button variant="primary" @click="showTemplatePage(1)">전화영어</b-button>
                <b-button variant="primary" class="ms-2" @click="showTemplatePage(2)">마이크로러닝</b-button>
                <b-button variant="primary" class="ms-2" @click="showTemplatePage(3)">AI튜터</b-button>
                <!-- <b-button variant="primary" class="ms-2" @click="showTemplatePage(5)">삼성전자DS_온라인 화상회화</b-button> -->
              </div>
              <Form @submit="onSubmit" ref="menuAddForm">
                <table class="table table-bordered table-light mt-3">
                  <thead>
                    <tr>
                      <th scope="col" class="txt-center"><input type="checkbox" true-value="Y" false-value="N" v-model="allCheck" /></th>
                      <th scope="col" class="txt-center">No</th>
                      <th scope="col" class="txt-center">메뉴명</th>
                      <th scope="col" class="txt-center">유형선택</th>
                      <th scope="col" class="txt-center">적용</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="menuList.length > 0">
                      <tr v-for="(templateItem, index) in menuList" :key="'template' + index">
                        <td class="cursor txt-center align-middle">
                          <input type="checkbox" true-value="Y" false-value="N" v-model="templateItem.isUse" @change="changeIsUse(index)" />
                        </td>
                        <td class="txt-center cursor txt-center align-middle">{{ index + 1 }}</td>
                        <td class="txt-center cursor txt-center">
                          <Field
                            :id="`menuName${index}`"
                            :name="`menuName${index}`"
                            label="메뉴명"
                            v-model="templateItem.menuName"
                            :rules="templateItem.isUse === 'Y' ? 'required|maxLength:9' : ''"
                            v-slot="{ field, errors }">
                            <b-form-input
                              :id="`menuName${index}`"
                              v-bind="field"
                              placeholder="메뉴명을 입력하세요"
                              :disabled="templateItem.isUse === 'Y' ? false : true"
                              v-model="templateItem.menuName"
                              @update:modelValue="updateModelValue(templateItem.menuName, index)"
                              :state="errors[0] ? false : null"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                          </Field>
                        </td>
                        <td class="txt-center cursor txt-center">
                          <Field
                            v-model="templateItem.isDirect"
                            :id="`isDirect${index}`"
                            :name="`isDirect${index}`"
                            label="유형선택"
                            :rules="templateItem.isUse === 'Y' ? 'required' : ''"
                            v-slot="{ field, errors }">
                            <b-form-select
                              @change="changeSelectType(templateItem)"
                              v-bind="field"
                              :id="`templateIdx${index}`"
                              v-model="templateItem.isDirect"
                              :disabled="templateItem.isUse === 'Y' ? false : true"
                              :options="selectType"
                              :state="errors[0] ? false : null"></b-form-select>
                            <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                          </Field>
                        </td>
                        <!-- 유형선택이 템플릿 -->
                        <td class="txt-center cursor txt-center" v-if="templateItem.isDirect == '' || templateItem.isDirect == '2' || templateItem.isDirect == null">
                          <Field
                            v-model="templateItem.templateIdx"
                            :id="`templateIdx${index}`"
                            :name="`templateIdx${index}`"
                            label="적용"
                            :rules="(templateItem.isUse === 'Y' && templateItem.isDirect == '') || templateItem.isDirect == '2' ? 'required' : ''"
                            v-slot="{ field, errors }">
                            <b-form-select
                              v-bind="field"
                              :id="`templateIdx${index}`"
                              v-model="templateItem.templateIdx"
                              :disabled="templateItem.isUse === 'Y' ? false : true"
                              :options="compTemlateList"
                              :state="errors[0] ? false : null"></b-form-select>
                          </Field>
                        </td>
                        <!-- 유형선택이 직접입력 -->
                        <td class="txt-center cursor txt-center" v-if="templateItem.isDirect == '1'">
                          <Field
                            v-model="templateItem.directUrl"
                            :name="`directUrl${index}`"
                            label="적용"
                            :rules="templateItem.isUse === 'Y' && templateItem.isDirect == 1 ? 'required' : ''"
                            v-slot="{ field, errors }">
                            <b-form-input
                              v-bind="field"
                              placeholder="ex) https://www.integrated-sugang.com"
                              :disabled="templateItem.isUse === 'Y' ? false : true"
                              v-model="templateItem.directUrl"
                              :state="errors[0] ? false : null"
                              class="self-choice"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                          </Field>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </Form>

              <div class="d-flex justify-content-between mt-2 align-items-center">
                <span>※ 템플릿의 추가/삭제는 개발팀에 문의해주세요 </span>
                <div class="d-inline-block">
                  <b-button variant="primary" @click="onSubmit">저장</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { templateListApi } from '@/api/integrateapi';
import { computed, onMounted, reactive, ref, watch } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { userSite } from '@/plugins/axios/apiUrl';
import _ from 'lodash';
export default {
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
    list: {
      type: Object,
      required: false,
      default() {
        return [];
      },
    },
  },
  emits: ['closeModal', 'returnData'],
  setup(props, cotext) {
    const allCheck = ref(false);
    let templateList = reactive([]);
    let menuList = reactive([
      {
        isUse: 'N',
        sort: 1,
        menuName: '',
        templateIdx: 0,
        directUrl: '',
        isDirect: 0,
      },
      {
        isUse: 'N',
        sort: 2,
        menuName: '',
        templateIdx: 0,
        directUrl: '',
        isDirect: 0,
      },
      {
        isUse: 'N',
        sort: 3,
        menuName: '',
        templateIdx: 0,
        directUrl: '',
        isDirect: 0,
      },
      {
        isUse: 'N',
        sort: 4,
        menuName: '',
        templateIdx: 0,
        directUrl: '',
        isDirect: 0,
      },
      {
        isUse: '',
        sort: 5,
        menuName: '',
        templateIdx: 0,
        directUrl: '',
        isDirect: 0,
      },
    ]);
    const selectType = [
      { text: '-선택-', value: '0' },
      { text: '템플릿 선택', value: '2' },
      { text: '직접 입력', value: '1' },
    ];
    const menuAddForm = ref(null);
    const store = useStore();

    const clickCloseModal = () => {
      cotext.emit('closeModal');
    };

    const apiTemplateList = () => {
      templateListApi()
        .then(resp => {
          const { success, data: respData } = resp.data;
          const { list } = respData;
          if (success) {
            list.forEach(item => {
              item['isChecked'] = false;
              templateList.push(item);
            });
          } else {
            templateList.length = 0;
          }
        })
        .catch(err => {
          templateList.length = 0;
          console.error('apiTemplateList error : ', err);
        });
    };

    const showTemplatePage = templateIndex => {
      //alert('준비중입니다.');
      window.open(`${userSite}/preview?type=${templateIndex}`);
    };

    const onSubmit = async () => {
      const { validate } = menuAddForm.value;
      const { valid } = await validate();

      if (!valid) {
        alert('필수 값을 확인해주세요');
        return false;
      }

      retunrMenuData();
    };

    const changeIsUse = async index => {
      if (menuList[index].isUse === 'N') {
        menuList[index]['templateIdx'] = 0;
        menuList[index]['menuName'] = '';
        menuList[index]['isDirect'] = 0;
        menuList[index]['directUrl'] = '';
      }
    };

    const retunrMenuData = () => {
      menuList.forEach(el => {
        el.directUrl;
        if (!el.directUrl.includes('http')) {
          //http 입력안했을경우 앞에 붙혀서 처리
          el.directUrl = 'http://' + el.directUrl;
        }
      });
      cotext.emit('returnData', _.cloneDeep(menuList));
    };

    const updateModelValue = (str, idx) => {
      if (str.length > 9) {
        menuList[idx]['menuName'] = menuList[idx]['menuName'].slice(0, 8);
      }
    };

    const compTemlateList = computed(() => {
      const clone = _.cloneDeep(store.getters.getTemplateList);
      clone.unshift({
        value: '0',
        text: '-선택-',
      });
      return clone;
    });

    const changeSelectType = obj => {
      obj.directUrl = '';
    };
    const convertNull = value => {
      return value || '';
    };
    watch(
      () => props.visible,
      cur => {
        if (cur) {
          if (props.list.length > 0) {
            menuList.length = 0;

            const cloneList = _.cloneDeep(props.list);
            console.log(props.list);
            cloneList.forEach(clone => {
              menuList.push(clone);
            });
          } else {
            menuList.forEach(item => {
              item['isUse'] = 'N';
              item['menuName'] = '';
              item['templateIdx'] = '';
              item['directUrl'] = '';
            });
          }

          apiTemplateList();
        }
      }
    );

    watch(
      () => allCheck.value,
      cur => {
        if (cur === 'Y') {
          menuList.forEach(menu => {
            menu['isUse'] = 'Y';
          });
        } else {
          menuList.forEach(menu => {
            menu['isUse'] = 'N';
          });
        }
      }
    );

    onMounted(() => {
      //apiTemplateList();
    });

    return {
      templateList,
      menuAddForm,
      onSubmit,
      menuList,
      clickCloseModal,
      showTemplatePage,
      compTemlateList,
      changeIsUse,
      allCheck,
      retunrMenuData,
      updateModelValue,
      selectType,
      changeSelectType,
      convertNull,
    };
  },
};
</script>

<style lang="scss">
.manage-menu {
  max-width: 1100px !important;
}

.self-choice {
  &::placeholder {
    color: #c1c1c1;
  }
}
</style>
